"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StreamSource = require("./StreamSource");
Object.keys(_StreamSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StreamSource[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StreamSource[key];
    }
  });
});